import { TxnSource } from '../money.model';

export const APPLE_HEADER = [
  'Transaction Date','Clearing Date','Description','Merchant',
  'Category','Type','Amount (USD)','Purchased By',
];

export const BANK_HEADER = [
  'Account Number','Post Date','Check','Description',
  'Debit','Credit','Status','Balance',
];

export const APPLE_ACCOUNT_ID = 'apple-card';

const clean = (cells: string[]): string[] =>
  cells.map(c => (c ?? '').replace(/^﻿/, '').trim().toLowerCase());

const matches = (header: string[], expected: string[]): boolean => {
  const got = clean(header);
  const want = clean(expected);
  return want.every(w => got.includes(w));
};

/** By header signature only — never by filename, never by guessing. */
export function detectSource(header: string[]): TxnSource | null {
  if (matches(header, APPLE_HEADER)) return 'apple-card';
  if (matches(header, BANK_HEADER)) return 'bank';
  return null;
}
